import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { BDSMForm } from '../../../../../components/form/BDSMForm';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { getClientDayNumber, saveClientDayNumber } from '../UserSettingsService';

export const MenuDayDeclarationBlock = () => {
    const { t } = useTranslation('settings');
    const alert = useAlert();
    const [dayNumber, setDayNumber] = useState({ dayNumberToday: 0 });

    const validation = Yup.object().shape({
        dayNumberToday: Yup.number().integer(t('validations:integer'))
            .min(1, t('validations:minInputNumber') + 1)
            .max(20, t('validations:maxInputNumber') + 20),
    });

    useEffect(() => {
        getClientDayNumber()
            .then((response) => setDayNumber({ dayNumberToday: response.data }))
            .catch(() => alert.error(t('alert:loadingError')));
    }, []);

    const handleSubmit = (record) => {
        saveClientDayNumber(record.dayNumberToday)
            .then(() => alert.success(t('alert:saveSuccess')))
            .catch(() => alert.error(t('alert:saveError')));
    };

    const cancel = () => {
        // ignore
    };

    const getFormModel = () => {
        return {
            initValues: dayNumber,
            onSubmit: (form) => handleSubmit(form),
            onCancel: (c) => cancel(c),
            validationSchema: validation,
            fieldNames: ['dayNumberToday'],
            className: 'mb-3',
            label: [t('menuDayDeclaration.menuDay')],
            types: ['number'],
            selectData: [null],
            inputFieldsClass: '',
            hideCancel: true
        };
    };

    return <BDSMForm form={getFormModel()} />;
};